import { SelectOption } from 'components/ui/Select/types';
import { languages } from 'constants/languages';

export const prepareLanguages = (): SelectOption[] =>
    Object.entries(languages).map(language => ({ value: language[0], label: language[1].name }));
